import { Component, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'app-pop-up-consulta',
  templateUrl: './pop-up-consulta.component.html',
  styleUrls: ['./pop-up-consulta.component.scss']
})
export class PopUpConsultaComponent implements OnInit {
  display = false;
  highContrast: boolean;
  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    setTimeout(() => {
      document.body.appendChild(this.el.nativeElement);
      this.display = true;
    }, 1000);

    if (localStorage.getItem('altoContraste') === 'true') {
      this.highContrast = true;
    }
    else {
      this.highContrast = false;
    }
  }

  closePopup(){
    document.body.removeChild(this.el.nativeElement);
  }

}
